module.exports = __webpack_public_path__ + "img/test.246d1f00.svg";